




















































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import QTableHeader from "@/common/qTableHeader.vue";
import QPaginate from "@/common/qPaginate.vue";
import QCalendar from "@/common/qCalendar.vue";
import PaginateModel from "@/model/paginate";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { FileManagementService as fileApi } from "@/common/api/services/FileManagementService";
import { GroupManagerService as groupApi } from "@/common/api/services/GroupManagerService";
import { namespace } from "vuex-class";
import { AwsService } from "@/common/api";
import qNotify from "@/common/qNotify";
const auth = namespace("Auth");

@Component({
  name: "FileIndex",
  components: {
    QTableHeader,
    QPaginate,
    QCalendar,
    Multiselect,
  },
})
export default class FileIndex extends Vue {
  @auth.Getter
  getUsingGroup!: string;

  public sharedFiles = [];

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
    perPage: 50,
  });

  public headers = [
    { id: "open_satatus", name: "ステータス", order: "desc" },
    { id: "created_at", name: "作成日", order: "" },
    { id: "post_date", name: "公開日", order: "" },
    { id: "title", name: "タイトル", order: "" },
    { id: "", name: "公開制限範囲" },
    { id: "createdBy", name: "作成者", order: "" },
    { id: "", name: "" },
  ];

  public searchParams = {
    title: "",
    sort: "default",
    direction: "desc",
    releaseStart: "",
    releaseEnd: "",
    status: null,
    createdBy: null,
    perPage: "50",
  };
  public statusOptions = [
    { id: "editing", name: "編集中" },
    { id: "wait", name: "公開待ち" },
    { id: "release", name: "公開中" },
    { id: "delete", name: "削除" },
  ];
  public selectedStatus = [];
  public selectedUser = [];

  public userOptions = [];
  public dateConfig = {};
  mounted() {
    this.filter(false, {}, true);
    this.getUsers();
  }

  public filter(clear = false, addition = {}, firstLoad = false): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }

    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    if (firstLoad) {
      this.searchParams = Object.assign(query);
      // auto select status
      if (this.searchParams.status && this.searchParams.status.length > 0) {
        if (typeof this.searchParams.status === "string") {
          this.searchParams.status = [this.searchParams.status];
        }
        this.selectedStatus = this.statusOptions.filter((item) =>
          this.searchParams.status.includes(item.id)
        );
      }
    }

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public async doSearch(query: any) {
    await this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query: any) {
    const parameters = { ...query, groupId: this.getUsingGroup };
    const { data } = await fileApi.groupAdminFiles(parameters);
    this.pagination = new PaginateModel({
      page: data.paginator.currentPage,
      pageCount: data.paginator.lastPages,
      start: data.paginator.currentPage,
      end: data.paginator.lastPages,
      count: data.paginator.total,
      perPage: data.paginator.perPage,
    });
    this.sharedFiles = data.list;
  }

  public async getUsers() {
    const parameters: any = { groupId: this.getUsingGroup };
    const { data } = await groupApi.adminGroupUsers(parameters);

    this.userOptions = data.users;

    if (this.searchParams.createdBy && this.searchParams.createdBy.length > 0) {
      if (typeof this.searchParams.createdBy === "string") {
        this.searchParams.createdBy = [this.searchParams.createdBy];
      }
      this.selectedUser = this.userOptions.filter((item) =>
        this.searchParams.createdBy.includes(item.id)
      );
    }
  }

  public resetSearch() {
    this.searchParams = {
      title: "",
      sort: "created_at",
      direction: "desc",
      releaseStart: "",
      releaseEnd: "",
      status: null,
      createdBy: null,
      perPage: "50",
    };
    this.selectedStatus = [];
    this.selectedUser = [];
    this.filter(true);
  }

  public isStatusChecked(status) {
    return this.selectedStatus.some((item) => item.id === status.id);
  }
  public changeStatus(value) {
    this.searchParams.status = value.map((item) => item.id);
  }

  public isUserChecked(user) {
    return this.selectedUser.some((item) => item.id === user.id);
  }
  public changeUser(value) {
    this.searchParams.createdBy = value.map((item) => item.id);
  }

  async download(file) {
    try {
      const result = await AwsService.awsDownloadFilePresign({
        filePath: file.files[0].name,
        filename: file.files[0].nameOriginal,
      });

      window.open(result.data.presign.url || "");
    } catch (error) {
      qNotify.error({
        text: error.message,
      });
    }
  }

  public getName(files) {
    if (files.length > 0) {
      return files[0].nameOriginal;
    }
    return "";
  }
}
